import React from 'react';
import PropTypes from 'prop-types';
import ExtensionsConstants from 'app/shared/constants/ExtensionsConstants';

import { Anchor, FormHelp } from '@zillow/constellation';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';


const propTypes = {
    containsMultiple: PropTypes.bool,
};

const defaultProps = {
    containsMultiple: false,
};

const InvalidFiletypeText = (props) => {
    const photosText = props.containsMultiple ? 'One or more of your photos' : 'The photo';
    const infoText = `${photosText} you tried to upload is an unsupported file type. `;
    const linkText = 'Click here for more information';
    const fileTypeText = 'Only the following file types are accepted:';

    const { paths, brand } = React.useContext(RMWContext);

    return (
        <FormHelp error={true}>
            { infoText }

            {
                brand === 'zillow' ? (
                    <Anchor href={paths.photosFormat} target="blank">
                        { linkText }
                    </Anchor>

                ) : (
                    `${fileTypeText} ${Object.values(ExtensionsConstants).join(', ')}`
                )
            }
        </FormHelp>
    );
};

InvalidFiletypeText.propTypes = propTypes;
InvalidFiletypeText.defaultProps = defaultProps;

export default InvalidFiletypeText;
